// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pageWrapper_wrapper__Fjawd","inner":"pageWrapper_inner__lKNaA"};